/**
 * Thin wrapper for /api/fax/* and /api/fax-matcher/* endpoints.
 * Consumed by the v2 Fax tab (pages/comms/fax/*). Keeps every fetch in
 * one place so auth headers / error shape / URL construction stay
 * consistent and don't sprinkle localStorage.getItem across components.
 */
const API = process.env.REACT_APP_BACKEND_URL;

function authHeader() {
  const token = localStorage.getItem("token") || "";
  return token ? { Authorization: `Bearer ${token}` } : {};
}

async function j(method, path, body, extraHeaders = {}) {
  const opts = {
    method,
    headers: { ...authHeader(), ...extraHeaders },
  };
  if (body !== undefined) {
    if (body instanceof FormData) {
      opts.body = body;
    } else {
      opts.headers["Content-Type"] = "application/json";
      opts.body = JSON.stringify(body);
    }
  }
  const res = await fetch(`${API}${path}`, opts);
  if (!res.ok) {
    let detail = `HTTP ${res.status}`;
    try { const t = await res.json(); detail = t.detail || t.message || detail; } catch { /* ignore */ }
    const err = new Error(detail);
    err.status = res.status;
    throw err;
  }
  const ct = res.headers.get("content-type") || "";
  if (ct.includes("application/json")) return res.json();
  return res.blob();
}

export const faxAPI = {
  // ── /api/fax/* ─────────────────────────────────────────────
  listSent:       (limit = 50)          => j("GET",  `/api/fax/sent?limit=${limit}`),
  listIncoming:   (limit = 50)          => j("GET",  `/api/fax/incoming?limit=${limit}`),
  send:           (formData)            => j("POST", `/api/fax/send`, formData),
  history:        (limit = 100)         => j("GET",  `/api/fax/history?limit=${limit}`),
  retry:          (faxId)               => j("POST", `/api/fax/retry/${faxId}`),
  retryQueue:     ()                    => j("GET",  `/api/fax/retry-queue`),
  autoRetryScan:  ()                    => j("POST", `/api/fax/auto-retry-scan`),
  refreshStatus:  (faxId)               =>
    faxId ? j("POST", `/api/fax/refresh-status/${faxId}`) : j("POST", `/api/fax/refresh-status`),
  coverPreview:   (payload, asImage=true) =>
    j("POST", `/api/fax/cover-sheet/preview?as=${asImage ? "image" : "pdf"}`, payload),
  templates:      ()                    => j("GET",  `/api/fax/templates`),
  createTemplate: (data)                => j("POST", `/api/fax/templates`, data),
  updateTemplate: (id, data)            => j("PUT",  `/api/fax/templates/${id}`, data),
  deleteTemplate: (id)                  => j("DELETE",`/api/fax/templates/${id}`),
  downloadSent:   (id)                  => `${API}/api/fax/download/sent/${id}`,
  downloadIncoming: (id)                => `${API}/api/fax/download/incoming/${id}`,

  // ── /api/fax-matcher/* ─────────────────────────────────────
  aiSuggestionStats: (days = 30)                                       => j("GET", `/api/fax-matcher/ai-suggestion-stats?days=${days}`),
  routeOptions:     (humblefaxId)                                       => j("GET", `/api/fax-matcher/route-to-intake/${humblefaxId}/options`),
  routeSuggest:     (humblefaxId)                                       => j("POST", `/api/fax-matcher/route-to-intake/${humblefaxId}/suggest`),
  routeToIntake:    (humblefaxId, payload)                              => j("POST", `/api/fax-matcher/route-to-intake/${humblefaxId}`, payload),
  autoRouteSettings: ()                                                  => j("GET",  `/api/fax-matcher/auto-route/settings`),
  updateAutoRoute:   (payload)                                           => j("PUT",  `/api/fax-matcher/auto-route/settings`, payload),
  autoRouteScan:     ()                                                  => j("POST", `/api/fax-matcher/auto-route/scan`),
  unmatched:         (limit = 50)                                        => j("GET",  `/api/fax-matcher/unmatched?limit=${limit}`),
  assignUnmatched:   (unmatchedId, payload)                              => j("POST", `/api/fax-matcher/unmatched/${unmatchedId}/assign`, payload),
  dismissUnmatched:  (unmatchedId, reason = "junk")                      => j("POST", `/api/fax-matcher/unmatched/${unmatchedId}/dismiss`, { reason }),
};
